import React, { useState } from 'react';
import { Layout, Menu, message } from 'antd';
import {
  CheckCircleOutlined,
  FileTextOutlined,
  BugOutlined,
  FileOutlined,
  EditOutlined,
} from '@ant-design/icons';
import ServiceStatus from './components/ServiceStatus';
import ViewLogs from './components/ViewLogs';
import KernelLogs from './components/KernelLogs';
import ViewFileContent from './components/ViewFileContent';
import EditFileContent from './components/EditFileContent';
import DebugXLogo from './resources/icons/DebugXlogo.png';
import './App.css';

const { Sider, Content } = Layout;

const App = () => {
  const [selectedKey, setSelectedKey] = useState('1');
  const [messageApi, contextHolder] = message.useMessage();

  const menuItems = [
    {
      key: '1',
      icon: <CheckCircleOutlined />,
      label: 'Check Service Status',
    },
    {
      key: '2',
      icon: <FileTextOutlined />,
      label: 'View Logs',
    },
    {
      key: '3',
      icon: <BugOutlined />,
      label: 'Kernel Logs',
    },
    {
      key: '4',
      icon: <FileOutlined />,
      label: 'View File Content',
    },
    {
      key: '5',
      icon: <EditOutlined />,
      label: 'Edit File Content',
    },
  ];

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      messageApi.success('Copied to clipboard!');
    } catch (err) {
      messageApi.error('Failed to copy text');
    }
  };

  const renderContent = () => {
    switch (selectedKey) {
      case '1':
        return <ServiceStatus onCopy={handleCopy} />;
      case '2':
        return <ViewLogs onCopy={handleCopy} />;
      case '3':
        return <KernelLogs onCopy={handleCopy} />;
      case '4':
        return <ViewFileContent onCopy={handleCopy} />;
      case '5':
        return <EditFileContent />;
      default:
        return <ServiceStatus onCopy={handleCopy} />;
    }
  };

  return (
    <Layout>
      {contextHolder}
      <Sider theme="dark" width={220}>
        <div className="logo-container">
          <img src={DebugXLogo} alt="DebugX Logo" className="sidebar-logo" />
        </div>
        <Menu
          theme="dark"
          selectedKeys={[selectedKey]}
          mode="inline"
          items={menuItems}
          onClick={({ key }) => setSelectedKey(key)}
        />
      </Sider>
      <Content style={{ padding: '24px', backgroundColor: 'var(--primary-color)', minHeight: '100vh' }}>
        {renderContent()}
      </Content>
    </Layout>
  );
};

export default App; 